<app-input [placeholder]="'admin.lifts.filters.toolUID' | translate"
           [formControl]="control('toolUID')">
</app-input>
<app-input [placeholder]="'admin.lifts.filters.toolName' | translate"
           [formControl]="control('toolName')">
</app-input>
<app-dropdown-autocomplete valueField="id"
                           displayField="name"
                           [emptyText]="'admin.strain.registry.create.step1.lines' | translate"
                           appendTo="body"
                           [resetValueOnOpen]="false"
                           [resetSelectionOnItemChange]="false"
                           [formControl]="control('line')"
                           [items]="lineOptions">
</app-dropdown-autocomplete>
